import { Component, OnInit } from '@angular/core';
import { MatDialogRef, MatDialogConfig, MatDialog } from '@angular/material';
import { NgForm } from '@angular/forms';
import { TemasVisualesEnum, TamanyosElementosEnum, ConfiguracionPersonalizacion, PersonalizacionDataService, TemaVisual, TamanyoElemento } from 'src/app/core/services/personalizacion-data.service';
import { MensajeriaUsuarioService } from 'src/app/core/services/mensajeria-usuario.service';
import { take } from 'rxjs/operators';
import { AyudaComponent } from './ayuda/ayuda.component';

/**
 * Componente para gestionar la configuracion de la
 * personalizacion por parte del usuario
 */
@Component({
  selector: 'tel-personalizar',
  templateUrl: './personalizar.component.html',
  styleUrls: ['./personalizar.component.scss'],
})
export class PersonalizarComponent implements OnInit {
  opcionesTemasVisuales: TemaVisual[];
  opcionesTamanyosElementos: TamanyoElemento[];
  configuracion: ConfiguracionPersonalizacion;

  constructor(public dialogRef: MatDialogRef<PersonalizarComponent>, private personalizacionDataService: PersonalizacionDataService, private mensajeriaUsuarioService: MensajeriaUsuarioService, private matDialog: MatDialog) {}

  ngOnInit() {
    this.cargarConfiguracionPersonalizacion();
    this.opcionesTemasVisuales = this.personalizacionDataService.obtenerTemasVisuales();
    this.opcionesTamanyosElementos = this.personalizacionDataService.obtenerTamanyosElementos();
  }

  private cargarConfiguracionPersonalizacion() {
    this.personalizacionDataService.configuracion.pipe(take(1)).subscribe((configPersonalizacion: ConfiguracionPersonalizacion) => {
      this.configuracion = Object.assign({}, configPersonalizacion);
    });
  }

  onGuardar(formulario: NgForm) {
    if (formulario.valid) {
      this.personalizacionDataService.guardarConfiguracion(this.configuracion);
      this.mensajeriaUsuarioService.notificarExito('Configuración guardada con éxito');
    }
    this.dialogRef.close();
  }

  abrirAyuda() {
    const dialogConfig = this.configurarModal();
    this.matDialog.open(AyudaComponent, dialogConfig);
  }

  private configurarModal() {
    const CONFIGURACION_ALTURA_MODAL: number = 1.2;
    const CONFIGURACION_ANCHURA_MODAL: number = 1.5;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = 'dialog-component-' + Math.random();
    dialogConfig.height = (screen.height / CONFIGURACION_ALTURA_MODAL).toString() + 'px';
    dialogConfig.width = (screen.width / CONFIGURACION_ANCHURA_MODAL).toString() + 'px';
    dialogConfig.panelClass = ['new_style', 'big_modal'];
    return dialogConfig;
  }
}
